export default {
    //token
    saveToken(state,payload){
        window.localStorage.setItem('token', payload)
        state.token=payload
    },
    //五档数据保存
  buy_px(state,payload){
    state.buy_px=payload
  },
  //盘口数据保存
  realTime(state,payload){
    state.realTime=payload
  },
  //明细数据保存
  tick(state,payload){
    state.tick=payload
  },
  //涨幅榜数据保存
  upList(state,payload){
    state.upList=payload
  },
  //跌幅榜数据保存
  downList(state,payload){
    state.downList=payload
  },
  //换手率榜数据保存
  turnoverList(state,payload){
    state.turnoverList=payload
  },
  //成交额榜
  businessList(state,payload){
    state.businessList=payload
  },
  //上证指数
  szList(state,payload){
    state.szList=payload
  },
  //5分钟涨幅榜
  riseList(state,payload){
    state.riseList=payload
  },
  //5分钟跌幅榜
  fivedownList(state,payload){
    state.fivedownList=payload
  },
  //行业板块
  industry(state,payload){
  state.industry=payload
},

}



// WEBPACK FOOTER //
// ./src/store/mutations.js